import { useEffect, useMemo } from "react";

import { useRefetchNotification } from "./useRefetchNotification";
import { disablePopupNotification } from "../../../store/slices/inAppNotification";
import { useAppDispatch, useAppSelector } from "../../../components/hooks";
import { NotificationMd } from "../../../models/notification";

export const useNotificationManager = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useRefetchNotification();
  const { data: inAppNotificationData, disablePopupNoti } = useAppSelector(
    (state) => state.inAppNotification,
  );

  const userNotifications = useMemo(
    () => NotificationMd.filterNotificationType(notifications),
    [notifications],
  );

  const { recentTime, newNotificationTime } = useMemo(() => {
    const storedTime = localStorage.getItem("recentNotificationTime") || "";
    const recent = storedTime !== "" ? new Date(storedTime).getTime() : 0;
    const current = new Date(userNotifications[0]?.createdAt).getTime();
    return { recentTime: recent, newNotificationTime: current };
  }, [userNotifications]);

  const shouldShowPopup =
    userNotifications?.length > 0 &&
    newNotificationTime > recentTime &&
    !disablePopupNoti;

  useEffect(() => {
    if (!notifications || disablePopupNoti) return;

    if (
      !userNotifications ||
      userNotifications.length === 0 ||
      newNotificationTime <= recentTime
    ) {
      dispatch(disablePopupNotification());
    }
  }, [notifications, disablePopupNoti, dispatch]);

  return { userNotifications, inAppNotificationData, shouldShowPopup };
};
